(function () {
  var source = document.getElementById('drool-edit-spots-source');
  if (!source) return;                       // not an edit collection -> exit

  // Confirmed on live grid (21 Jul 2026):
  var LIST = '.boost-sd__product-list';
  var ITEM = '.boost-sd__product-item';

  // Take the pre-rendered spot nodes out of the hidden source (once).
  var spots = Array.prototype.slice.call(source.querySelectorAll('.edit-spot'));
  if (!spots.length) return;
  spots.forEach(function (s) { s.parentNode.removeChild(s); });

  // A position-0 spot owns Boost's .wd-plp-spot-slot cell. Declared here, at init, so
  // plp-content-spot.js knows not to put its own tile there: that script is a deferred module
  // and this one is a classic in-body script, so this assignment always lands first. Without a
  // declared owner the two race on every Boost re-render and the loser's content disappears --
  // which is what removed the edit spot after a filter change.
  window.droolEditSpotOwnsSlot = spots.some(function (s) {
    return (parseInt(s.getAttribute('data-position'), 10) || 0) === 0;
  });

  // Every spot placed away from position 0 goes into one of these. The spot itself carries
  // 'mrk--sd__product-item', which Boost's grid CSS knows nothing about, so on its own it never
  // gets a real cell's width -- hence the wrapper. It doubles as the marker that tells
  // productsIn() and misplaced() this cell is not a product. 'wd-spot-cell' distinguishes ours
  // from the cell Boost renders at index 0, which we must not delete.
  function cellFor(spot) {
    if (spot.wdCell) return spot.wdCell;
    var cell = document.createElement('div');
    cell.className = 'boost-sd__product-item wd-plp-spot-slot wd-spot-cell';
    // classList, not className.indexOf: a substring test also matches 'edit-spot--full-width',
    // which the CSS would not, leaving a row-spanning cell with card image rules.
    if (spot.classList.contains('edit-spot--full')) cell.className += ' wd-spot-cell--full';
    cell.setAttribute('data-wd-spot-cell', '');
    cell.appendChild(spot);
    spot.wdCell = cell;
    return cell;
  }

  // Boost renders the position-0 cell itself, so cellFor() never sees it: tag it here instead, or
  // a full spot at position 0 could never span the row. Boost gives that cell an inline card
  // aspect-ratio, which no stylesheet rule can beat, so it is overridden inline and the original
  // stashed for restore. The else-if only ever touches a cell we marked, leaving every single-cell
  // slot exactly as Boost rendered it.
  function markSlotFull(slot, full) {
    if (!slot) return;
    if (full) {
      if (slot.wdPrevAspect === undefined) slot.wdPrevAspect = slot.style.aspectRatio || '';
      slot.classList.add('wd-spot-cell--full');
      slot.style.aspectRatio = 'auto';
    } else if (slot.classList.contains('wd-spot-cell--full')) {
      slot.classList.remove('wd-spot-cell--full');
      if (slot.wdPrevAspect !== undefined) {
        slot.style.aspectRatio = slot.wdPrevAspect;
        slot.wdPrevAspect = undefined;
      }
    }
  }

  // Real product cards in the grid (our own spots carry ITEM too, so filter them out).
  // Matched by node identity, not by class name: 'edit-spot-displaced' contains the substring
  // 'edit-spot', so a className test silently drops every displaced product from the count and
  // skews the position arithmetic below.
  function productsIn(list) {
    return Array.prototype.slice.call(list.querySelectorAll(ITEM))
      .filter(function (n) {
        // Boost also renders an empty .wd-plp-spot-slot cell carrying ITEM; it is not a product.
        return spots.indexOf(n) === -1 &&
               n.className.indexOf('wd-plp-spot-slot') === -1;
      });
  }

  // Boost is in load_more mode: the grid grows a page at a time rather than being replaced, so
  // a position past the last loaded product usually just hasn't paged in yet. Boost drops its
  // Load More button once the whole collection is on the page — that's the only point at which
  // an unreachable position is genuinely unreachable.
  function moreToLoad() {
    var btn = document.querySelector('.boost-sd__pagination-button--load-more');
    return !!(btn && btn.offsetParent !== null);
  }

  function place() {
    var list = document.querySelector(LIST);
    if (!list) return;
    // Detach everything placed on the previous pass (avoid dupes after a Boost re-render).
    // Removing our wrapper takes its spot with it; a spot sitting in Boost's own position-0 cell
    // is lifted out on its own, because that cell belongs to Boost's render, not to us.
    Array.prototype.forEach.call(list.querySelectorAll('.edit-spot'), function (n) {
      var cell = n.parentNode;
      if (cell && cell.hasAttribute && cell.hasAttribute('data-wd-spot-cell')) cell.remove();
      else n.remove();
    });
    // un-hide products hidden on a previous pass — the product set (and therefore which
    // ones are "last") changes on every filter / sort / paginate
    Array.prototype.forEach.call(list.querySelectorAll('.edit-spot-displaced'), function (n) {
      n.classList.remove('edit-spot-displaced');
    });
    var items = productsIn(list);
    var atEnd = !moreToLoad();
    var placed = [];
    // Boost renders an empty first cell (.wd-plp-spot-slot) that CSS has already sized, so a
    // position-0 spot can be dropped into it without moving a single product. Later positions
    // still insert into the grid -- they sit below the fold where a shift costs less.
    var slot = list.querySelector('.wd-plp-spot-slot');
    spots.forEach(function (spot) {
      var pos = parseInt(spot.getAttribute('data-position'), 10) || 0;  // AFTER product #pos
      // Straight into Boost's pre-sized slot cell. Deliberately not pushed to `placed`: the CSS
      // rule in plp-content-spot.liquid already hides one trailing product for this cell, so
      // counting it in the displacement maths below would hide a second card for no reason.
      if (pos === 0 && slot && (spot.parentNode === slot || !slot.childElementCount)) {
        if (spot.parentNode !== slot) slot.appendChild(spot);
        markSlotFull(slot, spot.classList.contains('edit-spot--full'));
        // Boost marks the empty cell aria-hidden. Now that it holds a link, leaving that on
        // would hide a tab-reachable control from screen readers.
        slot.removeAttribute('aria-hidden');
        return;
      }
      var node = cellFor(spot);                 // wrapper is what goes into the grid
      var ref = items[pos];                     // element that follows product #pos (0-based)
      if (ref && ref.parentNode) { list.insertBefore(node, ref); }
      // pos beyond the last LOADED product: hold the spot back rather than dropping it at the
      // end of the current page — it belongs to a later page and would otherwise show up early
      // (and in the wrong place) until that page loads. Falls to the end of the grid only once
      // nothing more can load, i.e. the position is genuinely beyond the collection.
      else if (atEnd) { list.appendChild(node); }
      else { return; }
      placed.push(node);
    });
    balance(list, items, placed, slot);
    watch();                                    // arm the document observer (idempotent)
  }

  // Widest row in the grid = the column count. Derived from measured positions rather than a
  // breakpoint table, because Boost's own responsive CSS decides it: taking the LARGEST row
  // occupancy keeps it right even when a full-width spot sits alone on a row.
  function columnsOf(list) {
    var kids = list.children;
    var rows = {};
    var cols = 1;
    var rowCount = 0;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].offsetParent === null) continue;   // display:none -> not on a row
      var top = Math.round(kids[i].offsetTop);
      if (!rows[top]) rowCount++;
      rows[top] = (rows[top] || 0) + 1;
      if (rows[top] > cols) cols = rows[top];
    }
    // One row only: the widest row is also the shortest, so the count above is the number of
    // products, not the column count. Nothing can overflow a row that never wraps.
    return rowCount > 1 ? cols : 0;
  }

  // Keep the grid a clean rectangle: the last row is either full or empty. Anything a content
  // spot pushed past the last complete row is hidden, rather than being left as a stub row of
  // one or two cards. Counts EVERY occupied cell -- products, our wrapper cells, and Boost's own
  // slot cell when it holds a spot -- which is what the two older rules each got wrong by
  // counting only their own. Class toggles don't fire the observer, so this cannot loop.
  function balance(list, items, placed, slot) {
    var cols = columnsOf(list);
    if (cols < 2) return;                       // single column: nothing can overflow a row
    var listWidth = list.getBoundingClientRect().width;
    var cells = items.length;
    // A spot that ACTUALLY spans the row consumes a whole row, so it shifts nothing. Measured,
    // not taken from the layout class: a full spot only spans the row once Boost's grid has
    // actually given the cell its width, and a stale or unstyled cell can still measure card-sized.
    placed.forEach(function (cell) {
      cells += cell.getBoundingClientRect().width < listWidth * 0.9 ? 1 : cols;
    });
    // Boost's own position-0 cell. The class is checked FIRST so a single-layout spot keeps the
    // original 'cells += 1' path exactly, with no measurement: only a cell we tagged full is worth
    // measuring, and it is measured like the wrappers above rather than trusted outright.
    if (slot && slot.childElementCount) {
      cells += slot.classList.contains('wd-spot-cell--full') &&
               slot.getBoundingClientRect().width >= listWidth * 0.9 ? cols : 1;
    }
    var overflow = cells % cols;
    for (var i = items.length - 1; overflow > 0 && i >= 0; i--, overflow--) {
      items[i].classList.add('edit-spot-displaced');
    }
  }

  // True when a spot has been dropped by a Boost re-render, or products were added/removed
  // around it so it no longer sits after product #pos. Gates the observer so place()'s own
  // inserts (which mutate the grid, re-firing the observer) can't loop.
  function misplaced(list) {
    var total = productsIn(list).length;
    var atEnd = !moreToLoad();
    for (var i = 0; i < spots.length; i++) {
      var spot = spots[i];
      var pos = parseInt(spot.getAttribute('data-position'), 10) || 0;
      // A position-0 spot lives inside Boost's slot cell rather than directly in the grid, so
      // the parentNode check below would call it misplaced forever. It is correctly placed for
      // as long as that cell is still in the document.
      var inSlot = spot.parentNode && spot.parentNode.classList &&
                   spot.parentNode.classList.contains('wd-plp-spot-slot');
      if (pos === 0 && inSlot) {
        if (!spot.parentNode.isConnected) return true;
        continue;
      }
      // Same rule place() applies: a spot whose page hasn't loaded is SUPPOSED to be out of the
      // grid. Without this the parentNode check below would report it misplaced on every grid
      // mutation and re-run place() in a loop.
      var node = spot.wdCell || spot;           // the wrapper is what sits in the grid
      if (pos >= total && !atEnd) {
        if (node.parentNode === list) return true;
        continue;
      }
      if (node.parentNode !== list) return true;
      var want = pos > total ? total : pos;     // pos beyond last -> expected at end of grid
      var before = 0;
      for (var n = node.previousElementSibling; n; n = n.previousElementSibling) {
        if (spots.indexOf(n) === -1 &&
            n.className.indexOf('wd-plp-spot-slot') === -1) before++;
      }
      if (before !== want) return true;
    }
    return false;
  }

  // Boost App Lib V3 native hook: ProductList afterRender fires on initial
  // client-side render and after every filter / sort / pagination re-render.
  // Must be registered before Boost's (deferred) script executes.
  window.__BoostCustomization__ = (window.__BoostCustomization__ || []).concat([
    function (componentRegistry) {
      componentRegistry.useComponentPlugin('ProductList', {
        name: 'drool-edit-spots',
        enabled: true,
        apply: function () {
          return {
            afterRender: function () {
              requestAnimationFrame(place);   // let Boost finish committing the list DOM
            }
          };
        }
      });
    }
  ]);

  // Document-scoped re-render watch. Boost REPLACES the product-list node on filter / sort /
  // paginate, so an observer bound to that node ends up watching a detached element and never
  // fires again -- which is why spots stopped reappearing after a filter was applied. Observing
  // document.body survives the swap. misplaced() gates the callback, so place()'s own inserts
  // (which mutate the grid and re-fire this) settle after one pass instead of looping.
  var observer = null;
  function watch() {
    if (observer) return;
    observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes.length && !m.removedNodes.length) continue;
        // Skip mutations we caused inside a spot cell.
        if (m.target && m.target.closest && m.target.closest('.wd-plp-spot-slot')) continue;
        var list = document.querySelector(LIST);
        if (list && misplaced(list)) place();
        return;
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // The grid is app-rendered by Boost and normally arrives AFTER this script runs, so there is
  // nothing to place into on DOMContentLoaded. Poll briefly until it exists, then place once —
  // the observer above takes over from there. Same approach as plp-content-spot.js, which
  // places the Build Your Bundle tile into this same grid.
  if (!document.querySelector(LIST)) {
    var tries = 0;
    var timer = setInterval(function () {
      if (document.querySelector(LIST)) { clearInterval(timer); place(); }
      else if (++tries > 40) clearInterval(timer);
    }, 250);
  } else {
    place();
  }
})();
